import moment from "moment";

const statusColors = {
  completado: "done",
  "en proceso": "active",
  "stand-by": "paused",
};

export const TaskStatus = ({ status }) => status ? (
  <span className={`tasks-badge tasks-badge--${statusColors[status] || "neutral"}`}>
    {status}
  </span>
) : null;

export const TaskDeadline = ({ date, status }) => {
  const deadline = moment(date);
  if (!date || !deadline.isValid()) {
    return <span className="tasks-muted">Sin fecha</span>;
  }

  const daysLate = moment().startOf("day").diff(deadline.startOf("day"), "days");
  const overdue = status !== "completado" && daysLate > 0;

  return (
    <span className={overdue ? "tasks-deadline-overdue" : undefined}>
      <time dateTime={deadline.format("YYYY-MM-DD")}>{deadline.format("DD/MM/YYYY")}</time>
      {overdue && <small>Vencida · {daysLate} {daysLate === 1 ? "día" : "días"}</small>}
      {daysLate === 0 && status !== "completado" && <small>Hoy</small>}
    </span>
  );
};
